module.exports = __webpack_public_path__ + "img/challenge-action.88fea5ce.svg";